import * as members from '../privates/privateMembers';

/*
 * @namespace wix-events
 */

class Events {
    constructor(appDefId){
        members._appDefId.set(this, appDefId);
    }
}

export default Events;
